import { render, staticRenderFns } from "./BusDetails.vue?vue&type=template&id=66181a57&"
import script from "./BusDetails.vue?vue&type=script&lang=js&"
export * from "./BusDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports